(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-trade"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initWholesaleForm = (root) => {
      const form = root.querySelector('.wholesale-trade__form');
      if (!form) return;

      const nameField = form.querySelector('[name="contact[name]"]');
      const bodyField = form.querySelector('[name="contact[body]"]');
      if (!nameField || !bodyField) return;

      const buildPackaging = () => {
        const boxes = form.querySelectorAll('[data-wholesale-pack]:checked');
        return Array.from(boxes)
          .map((el) => el.value)
          .join(', ');
      };

      form.addEventListener('submit', (e) => {
        const fn = (form.querySelector('[data-wholesale-fn]')?.value || '').trim();
        const ln = (form.querySelector('[data-wholesale-ln]')?.value || '').trim();
        nameField.value = `${fn} ${ln}`.trim();

        const biz = form.querySelector('[data-wholesale-business]')?.value?.trim() || '';
        const bizType = form.querySelector('[data-wholesale-business-type]')?.value?.trim() || '';
        const packaging = buildPackaging();
        const volume = form.querySelector('[data-wholesale-volume]')?.value?.trim() || '';
        const requirements = form.querySelector('[data-wholesale-requirements]')?.value?.trim() || '';
        const hear = form.querySelector('[data-wholesale-hear]')?.value?.trim() || '';

        if (!packaging) {
          e.preventDefault();
          const legend = form.querySelector('.wholesale-trade__fieldset .wholesale-trade__label');
          legend?.focus?.();
          alert('Please select at least one packaging format.');
          return;
        }

        const lines = [
          `Business name: ${biz}`,
          `Business type: ${bizType}`,
          `Packaging interested in: ${packaging}`,
          `Estimated monthly order volume: ${volume || '—'}`,
          '',
          'Purchase requirements:',
          requirements,
          '',
          `How did you hear about us: ${hear || '—'}`,
        ];
        bodyField.value = lines.join('\n');
      });

      const banner = root.querySelector('[data-wholesale-contact-success]');
      if (banner?.hidden) {
        const params = new URLSearchParams(window.location.search);
        if (params.get('contact_posted') === 'true') {
          const formHtmlId = form.getAttribute('id');
          const hash = window.location.hash;
          const wholesaleSections = document.querySelectorAll('.wholesale-trade');
          const hashMatches = !hash || !formHtmlId || hash === `#${formHtmlId}`;
          const onlyOneWholesale = wholesaleSections.length <= 1;
          if (hashMatches && (hash || onlyOneWholesale)) {
            banner.hidden = false;
            banner.focus({ preventScroll: true });
          }
        }
      }
    };

    document.querySelectorAll('.wholesale-trade').forEach(initWholesaleForm);
    document.addEventListener('shopify:section:load', (ev) => {
      const el = ev.target?.querySelector?.('.wholesale-trade');
      if (el) initWholesaleForm(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
